import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";

const LogoutButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      // Appel à l'API pour invalider le token côté serveur
      await axios.post("/logout");

      // Puis utilisation de la fonction logout du contexte qui gère la déconnexion côté client
      logout();
      navigate("/login");
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);

      // Même en cas d'erreur, on déconnecte l'utilisateur localement
      logout();
      navigate("/login");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed bottom-4 left-4">
      <button
        onClick={handleLogout}
        className="flex items-center gap-3 px-4 py-2 rounded-md hover:bg-green-50 transition-colors"
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="animate-spin text-green-500">⟳</span>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
          >
            <g clipPath="url(#clip0_1110_1951)">
              <path
                d="M11.2875 24.9994C11.0689 24.8819 10.8222 24.9067 10.5892 24.8689C8.13326 24.4858 6.00038 23.4265 4.16968 21.7655C2.1373 19.9224 0.759546 17.6746 0.240031 14.9655C-0.723942 9.93217 1.22358 4.7951 5.93837 1.90318C8.07517 0.592645 10.4065 -0.0580295 12.9153 0.00266749C15.9266 0.0751123 18.549 1.15656 20.8013 3.14651C21.2327 3.52766 21.2725 4.1255 20.9084 4.54124C20.5442 4.95698 19.9457 4.99811 19.494 4.59411C18.4426 3.65951 17.2672 2.93244 15.9299 2.49385C12.9975 1.53379 10.163 1.83793 7.47016 3.29336C4.89413 4.68547 3.11759 6.78245 2.34615 9.6326C1.00364 14.5928 3.13391 19.6385 7.99294 21.9678C9.79101 22.83 11.6915 23.1837 13.6789 22.9846C15.8555 22.7667 17.7632 21.9143 19.404 20.4693C19.6801 20.2259 19.9737 20.0562 20.3516 20.1338C20.7517 20.2167 21.0193 20.4602 21.1205 20.8609C21.2216 21.2616 21.095 21.584 20.7941 21.8471C19.863 22.6734 18.8131 23.3554 17.6797 23.8703C16.3546 24.4758 14.9326 24.8411 13.4798 24.9491C13.4413 24.9491 13.3969 24.9426 13.3845 24.9968H12.6522C12.3646 24.9172 12.0608 24.9172 11.7731 24.9968L11.2875 24.9994Z"
                fill="green"
              />
              <path
                d="M25.0103 13.0837C24.9268 13.1085 24.9451 13.1914 24.9314 13.2455C24.7991 13.8023 24.508 14.3086 24.0934 14.7029C23.0321 15.7472 21.9705 16.7914 20.9084 17.8357C20.4698 18.2651 19.8687 18.2717 19.4725 17.8624C19.0764 17.4532 19.1051 16.871 19.5332 16.4475C20.574 15.4184 21.6183 14.3914 22.666 13.3663C23.1979 12.8442 23.1959 12.3077 22.6588 11.7843C21.6146 10.7683 20.5703 9.75274 19.5261 8.73765C19.1893 8.41132 19.1077 7.99752 19.2878 7.60267C19.3683 7.42353 19.5012 7.27302 19.669 7.17105C19.8368 7.06908 20.0316 7.02045 20.2277 7.03159C20.4746 7.04532 20.7075 7.15103 20.8803 7.3279C21.9585 8.3765 23.0367 9.42619 24.1149 10.477C24.5728 10.9107 24.8726 11.485 24.9666 12.1086C24.9666 12.1269 24.9947 12.1413 25.0097 12.1569L25.0103 13.0837Z"
                fill="green"
              />
              <path
                d="M11.7764 24.9994C12.0639 24.9198 12.3676 24.9198 12.6551 24.9994H11.7764Z"
                fill="green"
              />
              <path
                d="M13.5583 11.5213C15.7552 11.5213 17.9524 11.5213 20.1502 11.5213C20.562 11.5213 20.8726 11.7034 21.0534 12.0728C21.2342 12.4422 21.184 12.7855 20.9399 13.1034C20.8575 13.21 20.7534 13.2979 20.6345 13.3611C20.5155 13.4244 20.3845 13.4616 20.25 13.4702C20.1849 13.4748 20.1195 13.4761 20.0542 13.4741C15.7258 13.4741 11.3965 13.4741 7.06636 13.4741C6.51878 13.4741 6.15264 13.2398 6.01819 12.8097C5.81064 12.1446 6.25967 11.5272 6.9665 11.5226C8.01075 11.5168 9.04912 11.5226 10.0908 11.5226L13.5583 11.5213Z"
                fill="green"
              />
            </g>
            <defs>
              <clipPath id="clip0_1110_1951">
                <rect width="25.0104" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        )}
        <span className="text-green-500">Déconnexion</span>
      </button>
    </div>
  );
};

export default LogoutButton;
